import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Products from '../components/Products';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import Validation from '../components/Validation';
import Contact from '../components/Contact';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Products />
      <WhyChooseUs />
      <Testimonials />
      <Validation />
      <Contact />
    </div>
  );
};

export default Home;
